<dx-data-grid
  [dataSource]="workflow.items"
  [allowColumnReordering]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showBorders]="true"
  keyExpr="order"
  [rowDragging]="{
    allowReordering: true,
    showDragIcons: true,
    onReorder: onReorder
  }"
  (onRowUpdated)="cellValueChanged($event)"
  (onRowRemoved)="removeItem($event)"
>
  <dxo-editing mode="cell" [allowUpdating]="true" [allowDeleting]="true" [useIcons]="true" />
  <dxi-column
    dataField="order"
    caption="{{ 'Order' | translate }}"
    [allowEditing]="false"
    [sortOrder]="'asc'"
    width="auto"
  />
  <dxi-column
    dataField="workflowItemType"
    caption="{{ 'Type' | translate }}"
    [allowEditing]="true"
    showEditorAlways="true"
    editCellTemplate="typeCellTemplate"
  />
  <dxi-column
    caption="{{ 'Einstellungen' | translate }}"
    [allowEditing]="true"
    showEditorAlways="true"
    editCellTemplate="settingsCellTemplate"
  />

  <div *dxTemplate="let column of 'typeCellTemplate'">
    <dx-select-box
      [(value)]="column.data.workflowItemType"
      [items]="itemTypes"
      (onValueChanged)="changeItemType($event)"
    ></dx-select-box>
  </div>

  <div *dxTemplate="let column of 'settingsCellTemplate'">
    <div [ngSwitch]="column.data.workflowItemType">
      <div *ngSwitchCase="'Makro'">
        <dx-button
          icon="edit"
          text="{{ getMarcoDesc(column.data) | translate }}"
          (onClick)="userActionWindow.showWindow(column.data.macroName, column.data.macroParameter)"
        ></dx-button>
        <app-user-action-window
          #userActionWindow
          [editMode]="true"
          (onMacroSave)="this.changeItemType(column.data, $event)"
        />
      </div>
      <div *ngSwitchCase="'Reimport'">
        <dx-button
          id="reimportTarget"
          icon="edit"
          text="{{ 'Reimport Einstellungen' | translate }}"
          (onClick)="reimportPopover.instance.show()"
        />

        <dx-popover
          target="#reimportTarget"
          #reimportPopover
          position="bottom"
          [width]="800"
          [showTitle]="true"
          title="Reimport Einstellungen"
        >
          <div *dxTemplate="let data = model; of: 'content'">
            <div class="dx-field">
              <div class="dx-field-label">{{ 'FTP Server' | translate }}</div>
              <div class="dx-field-value">
                <dx-lookup
                  [dataSource]="ftpServers"
                  valueExpr="id"
                  displayExpr="name"
                  (onValueChanged)="changeItemType($event)"
                  [(value)]="column.data.ftpServerId"
                />
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label" style="display: flex">
                {{ 'DateiPfad' | translate }}
                <div id="pathTT" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                <dx-tooltip target="#pathTT" showEvent="dxhoverstart" hideEvent="dxhoverend">
                  <div *dxTemplate="let data of 'content'">
                    <p>
                      {{ 'Ein optionaler Pfad der anstatt des FTP Server Import Pfad benutzt wird.' | translate }}
                    </p>
                    <p>
                      {{
                        'Hier können auch Feldnamen von Katalogfeldern wie CATALOG_NAME benutzt werden, um dynamisch einen Pfad zu bauen.'
                          | translate
                      }}
                    </p>
                    <p>
                      {{ 'Beispiel: "/home/CATALOG_ID/bme/"' | translate }}
                    </p>
                    <p>
                      {{
                        'Aktuell kann man folgende Felder benutzten: CATALOG_NAME, CATALOG_ID und BUYER_AID' | translate
                      }}
                    </p>
                  </div>
                </dx-tooltip>
              </div>
              <div class="dx-field-value">
                <dx-text-box (onValueChanged)="changeItemType($event)" [(value)]="column.data.ftpServerPath" />
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label" style="display: flex">
                {{ 'Unterverzeichnisse durchsuchen' | translate }}
                <div id="searchTT" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                <dx-tooltip target="#searchTT" showEvent="dxhoverstart" hideEvent="dxhoverend">
                  <div *dxTemplate="let data of 'content'">
                    <p>
                      {{
                        'Bei aktivem Schalter, werden auch alle unterverzeichnisse des angegeben Ordners durchsucht.'
                          | translate
                      }}
                    </p>
                  </div>
                </dx-tooltip>
              </div>
              <div class="dx-field-value">
                <dx-switch
                  (onValueChanged)="changeItemType($event)"
                  [(value)]="column.data.ftpServerRecursivePath"
                />
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">{{ 'Excel Template' | translate }}</div>
              <div class="dx-field-value">
                <dx-lookup
                  [dataSource]="excelTemplates"
                  (onValueChanged)="changeItemType($event)"
                  [(value)]="column.data.excelTemplateId"
                  [showClearButton]="true"
                  valueExpr="id"
                  displayExpr="name"
                />
              </div>
            </div>
          </div>
        </dx-popover>
      </div>
      <div *ngSwitchCase="'Export'">
        <dx-button
          id="exportTarget"
          icon="edit"
          text="{{ 'Export Einstellungen' | translate }}"
          (onClick)="exportPopover.instance.show()"
        />

        <dx-popover
          target="#exportTarget"
          #exportPopover
          position="bottom"
          [width]="800"
          [showTitle]="true"
          title="Export Einstellungen"
        >
          <div *dxTemplate="let data = model; of: 'content'">
            <div class="dx-field">
              <div class="dx-field-label">Export Konfiguration</div>
              <div class="dx-field-value">
                <dx-lookup
                  [dataSource]="exportConfigs"
                  valueExpr="id"
                  displayExpr="name"
                  (onValueChanged)="changeItemType($event)"
                  [(value)]="column.data.exportParameterId"
                />
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">FTP Server
                  <i id="helpedInfoExportTfpServer" class="dx-icon dx-icon-info"></i>
              </div>              
              <div class="dx-field-value">
                <dx-lookup [dataSource]="ftpServers"
                           valueExpr="id"
                           displayExpr="name"
                           (onValueChanged)="changeItemType($event)"
                           [(value)]="column.data.ftpServerId" />
              </div>
              <dx-tooltip target="#helpedInfoExportTfpServer"
                          showEvent="mouseenter"
                          hideEvent="mouseleave">
                <div *dxTemplate="let data = data; of: 'content'">
                  <div>
                    {{"für Export-Dateien (BMEcat/Excel) oder optional für Error-Logs bei anderen Schnittstellen (OSG, Shopware)" | translate}}                    
                  </div>
                </div>
              </dx-tooltip>
            </div>
          </div>
        </dx-popover>
      </div>

      <div *ngSwitchCase="'CategoryExport'">
        <dx-button
        icon="edit"
        text="{{ 'Export Einstellungen'| translate }}"
        (onClick)="exportCategoryWindow.visible = true"
      ></dx-button>

      <exportCategory #exportCategoryWindow [(visible)]="categoryExportVisible" [(model)]="column.data.exportParameter" (onValueChanged)="cellValueChanged()" [workflowMode]="true"/>
      </div>
    </div>
  </div>
</dx-data-grid>
